import React from 'react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { CurrencyNote } from '../CurrencyNote';
export function OfferTeaser() {
  return <section className="bg-navy-900 px-5 py-14 text-white sm:py-16" aria-labelledby="offer-teaser-title" data-id="element-286" data-mp="2321h9hlcwz4q">
      <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-287" data-mp="271s274o7cl1c">
        <h2 id="offer-teaser-title" className="font-display text-[28px] font-black uppercase leading-tight sm:text-4xl" data-id="element-288" data-mp="1ad3x18xl4s9c">
          Your special offer <span className="text-gold" data-id="element-289" data-mp="1f91hnrfvskrx">is waiting</span>
        </h2>
        <p className="mt-3 text-base text-white/80 sm:text-lg" data-id="element-290" data-mp="1jbxsgvz6jclb">
          Unlock the complete 6-volume clinical collection and all 5 bonuses for{' '}
          <strong className="text-white" data-id="element-291" data-mp="rlji39qdkiee">$27</strong>.
        </p>
        <div className="mt-8 w-full" data-id="element-292" data-mp="rlb5zk22th49">
          <CtaButton label="Unlock my clinical blueprint" data-id="element-293" data-mp="vmwp3n57ermw" />
        </div>
        <div className="mt-7 w-full" data-id="element-294" data-mp="vl22m4eaargp">
          <Countdown tone="dark" data-id="element-295" data-mp="3hsv1nng9ci8p" />
        </div>
        <div className="mt-7 flex w-full flex-col items-center gap-4" data-id="element-296" data-mp="3hrjxvnmtbahl">
          <ScarcityBar tone="dark" data-id="element-297" data-mp="3cubi1tp4ziji" />
          <CurrencyNote tone="dark" data-id="element-298" data-mp="3cvd0wkce99bs" />
        </div>
      </div>
    </section>;
}